import { FormGroup } from '@angular/forms';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit, OnDestroy, OnChanges {
  @Input() public placeholder: string;
  @Input() public bindLabel: string;
  @Input() public items: any[] = [];
  @Input() public multiple: boolean;
  @Input() public clearable = true;
  @Input() public formGroup: FormGroup;
  @Input() public formControlName: string;

  @Output() itemsChangeEvent = new EventEmitter<string[]>();

  buffer = [];
  bufferSize = 50;
  numberOfItemsFromEndBeforeFetchingMore = 10;
  loading = false;
  closeOnSelect = false;
  selectedValue: any;

  constructor() { }

  ngOnInit(): void {

  }

  selectedItemsEvent(responseValue) {
    this.itemsChangeEvent.emit(responseValue);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.multiple) {
      if (changes.multiple.currentValue === false) {
        this.closeOnSelect = true;
      }
      else {
        this.closeOnSelect = false;
      }
    }
  }

  onScrollToEnd() {
    this.fetchMore();
  }

  onScroll({ end }) {
    if (this.items) {
      if (this.loading || this.items.length <= this.buffer.length) {
        return;
      }

      if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.buffer.length) {
        this.fetchMore();
      }
    }
  }

  private fetchMore() {
    if (this.items) {
      const len = this.buffer.length;
      const more = this.items.slice(len, this.bufferSize + len);
      this.loading = true;
      // using timeout here to simulate backend API delay
      setTimeout(() => {
        this.loading = false;
        this.buffer = this.buffer.concat(more);
      }, 200)
    }
  }

  ngOnDestroy(): void {

  }

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation, controlName): boolean {
    const control = this.formGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName): boolean {
    const control = this.formGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
